// Reserved ad placeholder. Fixed height to avoid layout shift (CLS).
export const AdSlot = ({ variant = "inline", className = "" }) => {
  const isRail = variant === "rail";
  return (
    <div
      data-testid={isRail ? "ad-slot-rail" : "ad-slot-inline"}
      className={`rounded-2xl border bg-muted/30 p-3 flex flex-col gap-2 ${isRail ? "min-h-[600px] sticky top-24" : "min-h-[250px]"} ${className}`}
      aria-label="Werbeplatz"
    >
      <span className="text-[10px] uppercase tracking-wider text-muted-foreground">Anzeige</span>
      <div className="flex-1 rounded-xl border border-dashed border-border/70 flex items-center justify-center">
        <span className="text-xs text-muted-foreground">Werbeplatz reserviert</span>
      </div>
    </div>
  );
};
